//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FootButton from "../components/FooterBtn.vue";
import CcDialog from "../components/dialog.vue";
import Catalog from "../components/catalog.vue";

export default {
  name: "videoDetail",
  components: {
    // FootButton,
    CcDialog,
    Catalog
  },
  metaInfo() {
    return {
      meta: this.metas,
    };
  },
  data() {
    return {
      imgNone: require("@/assets/image/photo/p1.jpg"),
      iconAll: {
        iconNone: require("@/assets/image/icon/dele.png"),
        iconPlay: require("@/assets/image/icon/icon_play.png")
      },
      mediaId: null,
      mediaData: {},
      pageData: "",
      isNative: false,
      metas: [],
      BuyDialog: false,
      show: false,
      videoUrl: '',
      imgNull: require("@/assets/image/icon/icon_null.png"),
      errData:{
        code:false
      },
      posterUrl: '',
      accessRegion:true,//true 为可以进行阅读，false说明ip为非可阅读区域ip
      isList: ''
    };
  },
  methods: {
    openApps() {
      this.BuyDialog = !this.BuyDialog;
    },
    //返回上一页
    onClickLeft(){
      //this.$router.go(-1)
      this.$router.back()
    },
    goBuy() {
      // this.OPENAPP();
      if (this.isMobile) {
        this.OPENAPP();
      } else {
        window.location.href = "http://nowbook.hk/#/download";
      }
    },
    getData() {
      //獲取詳情
      let mediaPost = {
        id: this.mediaId
      };
      //
      this.CCrequest.doAxios(this.CONFIG.MEDIA.GET, mediaPost, "GET")
        .then(res => {
          console.log('獲取詳情res', res);
          this.mediaData = res;
          this.getVideoUrl(this.mediaData.id);

          this.show = true;
          this.metas = [
            { property: "fb:app_id", content: "334680360390712" },
            { property: "og:title", content: res.title },
            {
              property: "og:url",
              content: `${this.SERVER.SHARE_DOMAIN}share/index.html#/video?id=${this.mediaId}`
            },
            { property: "og:type", content: "website" },
            { property: "og:description", content: res.subTitle },
            {
              property: "og:image",
              content: res.coverUrl + "?x-oss-process=image/resize,w_640"
            },
            { property: "og:image:type", content: "image/jpeg" }
          ];
        })
        .catch(err => {
          console.log("request err", err);
          //獲取多媒體數據異常
            if(err.response.data &&err.response.data.message){
                this.errData = err.response.data
              }

        });
        //获取目录列表
      // if(this.columnId == ''){
      //   this.getcolumn(this.mediaData.id);
      // }
    },
    getcolumn(){
      let columnPost = {
        id: this.columnId
      };
      this.CCrequest.doAxios(this.CONFIG.COLUMN.GET, columnPost, "GET").then(res => {
          this.pageData = res;
          console.log('专辑res',res);

          this.getAudioData(res.items); //音频列表
        }).catch(err => {
          if(err.response.data &&err.response.data.message){
              this.errData = err.response.data
          }
        console.log('errData',this.errData);
      });
    },
    getVideoUrl(mediaId){
      this.CCrequest.doAxios(`${this.CONFIG.NOWBOOK.SHARE_VIDEO_URL}${mediaId}`, {}, 'GET').then(url => {
        this.videoUrl = url;
        console.log(url)
        this.posterUrl = this.mediaData.coverUrl || '';
        this.initVideo();
      });
    },
    initVideo() {
      //初始化视频
      // let myPlayer = this.$video('myVideo', {
      //     controls: true,
      //     preload: "auto",
      //     width: "100%",
      //     height: ""
      // });
    },
    //列表切换
    onChangeMediaData (data,index) {
      console.log("back", data);
      if (data.detailCoverUrl) {
        this.detailCoverUrl = data.detailCoverUrl;
      } else {
        this.detailCoverUrl = this.pageDataDetailCoverUrl;
      }
      //this.onPlay(index);
      //this.audionIndex = index
    },
    type(type) {
      this.paly = type;
      console.log(type);
    }
  },
  created() {},
  mounted() {
    this.mediaId = this.$route.query.id;
    this.columnId = this.$route.query.columnId;
    this.getData();
  }
};



// WEBPACK FOOTER //
// ./src/pages/videoDetail.vue